export const OVERLAY_HEIGHT = 74;
export const BUTTON_BOTTOM_OFFSET = 17;
export const UPPER_GRADIENT_RATIO = 0.85;
export const LOWER_GRADIENT_RATIO = 0.15;
